/* eslint-disable simple-import-sort/imports */
import './i18n'; // Path to this i18n configuration file
import { useLocation } from 'react-router-dom';
import { StyledEngineProvider, ThemeProvider } from '@mui/material';
import NoInternetModal from 'components/Common/NoInternetModal';
import { MyProvider } from 'Context';
import { TabProvider } from 'Context/TabContext';
import { TextAreaProvider } from 'Context/TextAreaContext';
import { ClearNoteProvider } from 'Context/ClearNoteContext';
import React, { useEffect, useState } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ToastContainer } from 'react-toastify';

import { SidebarProvider } from 'Context/SidebarProvider';
import { LeftPanelProvider } from 'Context/LeftPanelContext';
import { LeftPanelNewProvider } from 'Context/LeftPanelNewContext';
import { MobileTabProvider } from 'Context/MobileTabContext';
import { ScribeFormProvider } from 'Context/ScribeFormContext';
import Routes from './routes';
import PrimaryTheme from './styles/PrimaryTheme';

function App() {
  const location = useLocation();
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        // cacheTime: 1000 * 60 * 7,
        // enabled: false,
        retry: 1,
        staleTime: Infinity,
      },
    },
  });
  useEffect(() => {
    // Set the document title from the environment variable
    document.title = process.env.REACT_APP_WEB_TITLE || '';

    // Set the favicon dynamically
    const favicon = document.getElementById(
      'dynamic-favicon'
    ) as HTMLLinkElement;
    if (favicon) {
      favicon.href = `${process.env.PUBLIC_URL}/${
        process.env.REACT_APP_FAVICON || 'favicon.ico'
      }`;
    }
  }, [location.pathname]);

  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const updateOnlineStatus = () => {
      setIsOnline(navigator.onLine);
      if (navigator.onLine) {
        setShowModal(false); // Close the modal when internet is restored
      } else {
        setShowModal(true);
      }
    };

    window.addEventListener('online', updateOnlineStatus);
    window.addEventListener('offline', updateOnlineStatus);

    return () => {
      window.removeEventListener('online', updateOnlineStatus);
      window.removeEventListener('offline', updateOnlineStatus);
    };
  }, []);

  return (
    <div className="App">
      <QueryClientProvider client={queryClient}>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={PrimaryTheme}>
            <ToastContainer />
            <ClearNoteProvider>
              <TextAreaProvider>
                <TabProvider>
                  <SidebarProvider>
                    <LeftPanelProvider>
                      <LeftPanelNewProvider>
                        <MobileTabProvider>
                          <ScribeFormProvider>
                            {/* <Layout> */}
                            <MyProvider>
                              <Routes />
                            </MyProvider>
                            {/* </Layout> */}
                          </ScribeFormProvider>
                        </MobileTabProvider>
                      </LeftPanelNewProvider>
                    </LeftPanelProvider>
                  </SidebarProvider>
                </TabProvider>
              </TextAreaProvider>
            </ClearNoteProvider>
          </ThemeProvider>
        </StyledEngineProvider>
      </QueryClientProvider>
      <NoInternetModal open={showModal} onClose={() => setShowModal(false)} />
    </div>
  );
}

export default App;
